// extracted by mini-css-extract-plugin
module.exports = {"section":"content-section_section__1EKf7"};